import { createContext } from 'react';
import { AppContract } from '../Types/app';
export const GlobalContext = createContext<AppContract>({
	userName: '',
	isAuthenticated: false,
	doLogin: () => {
		return null;
	}
});
